const items = [
  {
    id: 'option-1',
    label: 'Option 1',
  },
  {
    id: 'option-2',
    label: 'Option 2',
  },
  {
    id: 'option-3',
    label: 'Option 3',
  },
  {
    id: 'option-4',
    label: 'Option 4',
  },
];

export default items;
